'use client'

import { useTranslate } from '../../hooks'
import { Link } from '../../i18n/navigation'
import { Row } from '@repo/ui/components'

export type LandingFooterNavigationLinksConfig = { href: string; key: string }[]
interface LandingFooterNavigationSectionProps {
  className?: string
  gap?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
  direction?: 'horizontal' | 'vertical'
  mobileColumns?: 1 | 2 | 3
  links: LandingFooterNavigationLinksConfig
}

export const LandingFooterNavigationSection = ({
  className = '',
  gap = '4xl',
  direction = 'horizontal',
  mobileColumns = 1,
  links,
}: LandingFooterNavigationSectionProps) => {
  const { t } = useTranslate()

  const gapConfig = {
    sm: 'gap-sm',
    md: 'gap-md',
    lg: 'gap-lg',
    xl: 'gap-xl',
    '2xl': 'gap-2xl',
    '3xl': 'gap-3xl',
    '4xl': 'gap-4xl',
  }

  const directionConfig = {
    horizontal: 'flex items-center',
    vertical: 'flex flex-col items-center',
  }

  const mobileColumnsConfig = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
  }

  return (
    <Row
      className={`${directionConfig[direction]} ${gapConfig[gap]} ${className} md:flex md:items-center md:gap-${gap} grid ${mobileColumnsConfig[mobileColumns]} gap-${gap} md:grid-cols-none`}
    >
      {links.map((link) => (
        <Link
          key={link.key}
          href={link.href}
          className='text-sm text-neutral-surface-100 hover:underline text-right'
          prefetch='auto'
        >
          {t(link.key as keyof typeof t)}
        </Link>
      ))}
    </Row>
  )
}
